// extracted by mini-css-extract-plugin
module.exports = {"s1wslf2n":"s1wslf2n","s1wls44k":"s1wls44k"};